import { callApiWithToken } from "../utils/http_common";

const getCollectionOverview = () => {
  return callApiWithToken.get(`/transaction/collectionOverview`);
};

const getBalanceAccounts = () => {
  return callApiWithToken.get(`/account/list`);
};

const BalanceService = {
  getCollectionOverview,
  getBalanceAccounts,
};

export default BalanceService;
